// extracted by mini-css-extract-plugin
module.exports = {"container":"Rw-z","list":"Sw-z"};